import { http } from '@/lib/http';
import type { APIResponse } from '@/types';
import { EcItemListItem } from '../types';

export type GetEcItemListParams = {
  oemServiceId: number;
  requestTime: string;
  getType: 'new' | 'on_sale' | 'random' | 'new_held' | 'has_stock';
  pagingEcItemId?: number;
  paging?: string;
  limit?: number;
  itemName?: string;
  bizCreatorId?: number;
  bizTeamId?: number;
  contentType?: string;
};

export type GetEcItemListResponse = APIResponse<Array<EcItemListItem>>;

export const getEcItemList = async (params: GetEcItemListParams) => {
  return await http<GetEcItemListResponse>('/user/v1/ec-item', {
    query: {
      oem_service_id: params.oemServiceId,
      request_time: params.requestTime,
      get_type: params.getType,
      paging_ec_item_id: params.pagingEcItemId,
      paging: params.paging,
      limit: params.limit,
      item_name: params.itemName,
      biz_creator_id: params.bizCreatorId,
      biz_team_id: params.bizTeamId,
      content_type: params.contentType,
    },
  });
};
